module.exports = __webpack_public_path__ + "media/images/subscribe-icon-yp-b256d40d.svg";